import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Row, Label, Button } from "reactstrap";
import { FaCloudDownloadAlt } from "react-icons/fa";
import SweetAlert from "react-bootstrap-sweetalert";
import { CircularProgress } from "@material-ui/core";

const ExportAEMStoresPage = () => {
  const [loading, setLoading] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [token, setToken] = useState();
  const [emailRecipients, setEmailRecipients] = useState("");
  const [dataLoading, setDataLoading] = useState(true);
  const [saveLoading, setSaveLoading] = useState(false);
  const [aemEmailId, setAemEmailId] = useState(null);
  const [emailValidationError, setEmailValidationError] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    getEmailRecipients(token);
  }, []);

  const getEmailRecipients = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208",
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=settings&env=production`,
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        const aemEmailObj = result?.settings?.find(
          (item) => item?.item_name === "aem_store_email_recipients",
        );
        if (aemEmailObj && aemEmailObj?.item_detail) {
          setEmailRecipients(aemEmailObj?.item_detail);
          setAemEmailId(aemEmailObj?.item_id);
        }
        setDataLoading(false);
      })
      .catch((error) => {
        console.log("Error fetching settings:", error);
        setDataLoading(false);
      });
  };

  const validateEmails = (emails) => {
    if (!emails.trim()) {
      return "";
    }

    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailList = emails?.split(",").map((email) => email.trim());
    const invalidEmails = emailList?.filter((email) => !pattern.test(email));

    if (invalidEmails.length > 0) {
      return `Please enter valid email addresses (separated by commas)`;
    }

    return "";
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmailRecipients(value);
    
    // Validate emails on change
    const validationError = validateEmails(value);
    setEmailValidationError(validationError);
  };

  const handleSaveEmailRecipients = () => {

    // Validate emails before saving
    const validationError = validateEmails(emailRecipients);
    if (validationError) {
      setEmailValidationError(validationError);
      return;
    }else{
      setEmailValidationError("");
    }

    setSaveLoading(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208",
    );

    var formdata = new FormData();
    formdata.append("item_id", aemEmailId);
    formdata.append("path", "settings/update");
    formdata.append("item_type", "settings");
    formdata.append("item_name", "aem_store_email_recipients");
    formdata.append("item_detail", emailRecipients ? emailRecipients : "");
    formdata.append("item_version", 18);
    formdata.append("item_status", "Y");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          setSuccessAlert(true);
          setSaveLoading(false);
        } else {
          setErrorAlert(true);
          setSaveLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error updating email recipients:", error);
        setErrorAlert(true);
        setSaveLoading(false);
      });
  };

  const downloadCSV = (csvContent, filename) => {
    // Create blob with BOM for Excel compatibility
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleExport = async () => {
    if (loading) return;

    setLoading(true);
    setErrorAlert(false);

    try {
      if (!token) {
        throw new Error("Authentication token not found");
      }

      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
      myHeaders.append("Authorization", "Bearer " + token);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_TOKRI_API_URL}/api/download-stores-csv`,
        requestOptions,
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      // Get CSV content directly from response
      const csvContent = await response.text();
      const filename = `AEM_Stores_${new Date().toISOString().split("T")[0]}.csv`;
      downloadCSV(csvContent, filename);
    } catch (error) {
      console.error("Error exporting stores:", error);
      setErrorAlert(true);
    } finally {
      setLoading(false);
    }
  };

  const renderErrorAlert = () => {
    return (
      <SweetAlert
        title="Error!"
        danger
        confirmBtnBsStyle="danger"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {"Failed to save email recipients. Please try again."}
      </SweetAlert>
    );
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          setSuccessAlert(false);
        }}
      >
        {"Email recipients updated successfully."}
      </SweetAlert>
    );
  };

  return (
    <React.Fragment>
      <style>
        {`
          .export-dropzone:hover .export-icon {
            color: #34c38f !important;
            transition: color 0.3s ease;
          }
          .email-error {
            color: #ff0000;
            font-size: 12px;
            margin-top: 5px;
          }
        `}
      </style>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Export AEM Stores" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody style={{ paddingTop: "3rem", paddingBottom: "3rem" }}>
                  <Row className="justify-content-center">
                    <Col lg={10} md={12} sm={12}>
                      <div
                        className="dropzone export-dropzone"
                        onClick={handleExport}
                        style={{
                          cursor: loading ? "not-allowed" : "pointer",
                          opacity: loading ? 0.6 : 1,
                          minHeight: "300px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div className="dz-message needsclick text-center">
                          <div className="mb-3">
                            <FaCloudDownloadAlt
                              className="display-4 text-muted export-icon"
                              style={{ fontSize: "4rem", transition: "color 0.3s ease" }}
                            />
                          </div>
                          <h4 style={{ color: "#495057", marginBottom: "10px" }}>
                            {loading ? "Exporting..." : "Click here to export AEM Stores"}
                          </h4>
                          <p style={{ fontSize: "14px", color: "#6c757d", marginBottom: "5px" }}>
                            {loading ? "Please wait while we prepare your file..." : "Download AEM Stores data as CSV file"}
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <Row className="mb-4">
                    <Col lg={6}>
                      <div className="mb-3">
                        <Label>Monthly AEM Store export recipients (sent 1st of each month)</Label>
                        <textarea
                          rows="4"
                          className="form-control"
                          id="email_recipients_input"
                          value={emailRecipients}
                          onChange={handleEmailChange}
                          placeholder="Enter email recipients..."
                          style={{
                            border: "2px solid rgb(238, 238, 238)",
                          }}
                        />
                        {emailValidationError && (
                          <div className="email-error">{emailValidationError}</div>
                        )}
                      </div>
                      <div className="mb-3">
                        <Button
                          disabled={saveLoading}
                          color="success"
                          onClick={handleSaveEmailRecipients}
                          style={{ width: "100px" }}
                        >
                          {saveLoading ? (
                            <CircularProgress
                              size={15}
                              value={100}
                              color={"white"}
                            />
                          ) : (
                            "Save"
                          )}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {errorAlert ? renderErrorAlert() : null}
          {successAlert ? renderSuccessAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ExportAEMStoresPage;

